import React, { useState } from 'react';
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import usePermission from '../../config/permissions';
import { AssignedCriticalTasks, MyCriticalTasks } from './TasksTables';

const CriticalTaskManagement = () => {
    const { SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook

    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'My Critical Tasks';
            case 2:
                return 'All Critical Tasks';
            default:
                return 'Critical Tasks Management';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Tickets Managment" />
            {PERMISSION_AUTHORITY ?
                <div className="bloc-tabss2  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        My Critical Tasks
                    </button>
                    < button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        All Tasks
                    </button>

                </div>
                : null
            }
            <div>
                {toggleState === 1 ? <MyCriticalTasks /> : null}
                {toggleState === 2 ? <AssignedCriticalTasks /> : null}
            </div>
        </>
    );
};

export default CriticalTaskManagement;